import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmptyComponent } from './components/empty/empty.component';

// Authentication is handled solely by BootstrapingService; a route guard here would start a concurrent loginRedirect.
const routes: Routes = [
  {
    path:'',
    component: EmptyComponent
  },
  {
    path: 'access_token',
    component: EmptyComponent
  }
];

@NgModule({
  imports: 
  [
    RouterModule.forRoot(routes,{
    useHash: true
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
